document.addEventListener("DOMContentLoaded", function(event) {
	// Make sure we're on the right page
    if (!document.querySelector('[name="EndOfYearLrp1-your_work_and_community"]') 
    	&& !document.querySelector('[name="EndOfYearSp1-your_work_and_community"]')
    	&& !document.querySelector('[name="EndOfContractLrp1-your_work_and_community"]')
    	&& !document.querySelector('[name="EndOfContractSp1-your_work_and_community"]')
    	&& !document.querySelector('[name="SuppEndOfYearLrp1-your_work_and_community"]')
    	&& !document.querySelector('[name="SuppEndOfYearSp1-your_work_and_community"]')
    	&& !document.querySelector('[name="SuppEndOfContractLrp1-your_work_and_community"]')
    	&& !document.querySelector('[name="SuppEndOfContractSp1-your_work_and_community"]')) {
        return;
    }

    var originalPracName = $('input[name=PracName]').val();
    $('input[name=PracName]').change( function () {
        if ($('input[name=PracName]').val() != originalPracName) {
        	var originalQuestionText = $('#Recommend > .question-text').html();
        	var updatedQuestionText = originalQuestionText.replace(originalPracName, $('input[name=PracName]').val());
        	$('#Recommend > .question-text').html(updatedQuestionText);
        }
    });
});